module.exports = __webpack_public_path__ + "images/stickers/laugh@2x.1543ad1f70c0963f5fbb.png";